export default __webpack_public_path__ + "static/assets/6b97c339931010f9b10cc0b6d2bd49ff.svg";